import { render, staticRenderFns } from "./UserBase.vue?vue&type=template&id=7aa38f81&"
import script from "./UserBase.vue?vue&type=script&lang=ts&"
export * from "./UserBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports